
import { AppContractStepCreditLetterComponent } from "../components/contract-step-credit-letter/contract-step-credit-letter.component";
import { AppContractStepDocumentComponent } from "../components/contract-step-document/contract-step-document.component";
import { AppContractStepMultiPaymentComponent } from "../components/contract-step-multi-payment/contract-step-multi-payment.component";
import { AppContractStepPaymentComponent } from "../components/contract-step-payment/contract-step-payment.component";
import { AppContractStepSubContractComponent } from "../components/contract-step-subcontract/contract-step-subcontract.component";
import { AppContractStepTaskComponent } from "../components/contract-step-task/contract-step-task.component";
/* Union */
  const colorGradientsTtasks = 'linear-gradient(to bottom, rgba(255,250,229,1) 0%,rgba(255,238,169,1) 100%)';
	const colorGradientsTdocs = 'linear-gradient(to bottom, rgba(240,245,255,0.939) 0%,rgba(188,211,255,0.737) 100%)';
	const colorGradientsTpayments = 'linear-gradient(to bottom, rgba(238,255,244,0.932) 0%,rgba(177,241,201,0.693) 100%)';
	const colorGradientsTsubs = 'linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(230,230,230,0.900) 100%)';
	const colorGradientsTtasksHover = 'linear-gradient(to bottom, rgba(255,244,200,1) 0%,rgba(239,209,88,0.938) 100%)';
	const colorGradientsTdocsHover = 'linear-gradient(to bottom, rgba(218,231,255,0.853) 0%,rgba(115,161,246,0.450) 100%)';
	const colorGradientsTpaymentsHover = 'linear-gradient(180deg, #D5FFE5 0%, #57D185 100%)';
	const colorGradientsTsubsHover = 'linear-gradient(to bottom, rgba(245,245,245,0.963) 0%,rgba(197,197,197,0.774) 100%)';
  /* Union */

 export interface IDivStyles {
  top:number, 
  height:number,
  stepIsCalculated:boolean
}
export interface IStepComponent {
    component: any
}
export interface IStepStyles {
  stepColor:string,
  subCountractStepColor:string,
  stepActiveColor:string,
  stepIcon:string,
  stepViewBackGround:string,
  pointerColor:string,
  stepDeadlineColor:string
}
export const ContractPaymentStatusIconMap:Map<string,string> = new Map([
  ['NEW','time-fill.svg'],
  ['PROMISED','time-fill.svg'],
  ['EXECUTION','time-fill.svg'],
  ['APPROVED','checkbox-fill-green-border.svg'],
  ['SUCCESS','checkbox-fill-green-border.svg'],
  ['CANCELED','close-circle-fill.svg'],
])
export const ContractStatusIconMap:Map<string,string> = new Map([
  ['open','time-line'],
  ['verified','checkbox-circle-line'],
  ['pre_verified','file-edit-line'],
  ['completed','flag-line'],
  ['pause','pause-line'],
  ['renegotiated','file-check-line'],
  ['closed','close-circle-line'],
])
export const STEPS_COMPONENT_MAP:Map<string,IStepComponent> = new Map([
  ['task',{component:AppContractStepTaskComponent}],
  ['file',{component:AppContractStepDocumentComponent}],
  ['credit_letter',{component:AppContractStepCreditLetterComponent}],
  ['general_credit_letter',{component:AppContractStepCreditLetterComponent}],
  ['direct_payment',{component:AppContractStepPaymentComponent}],
  ['payment',{component:AppContractStepPaymentComponent}],
  ['sub_contract',{component:AppContractStepSubContractComponent}],
  ['multi_payment',{component:AppContractStepMultiPaymentComponent}],
])

type TStepType = 'task'|'file'|'credit_letter'|'direct_payment'|'payment'|'multi_payment'|'sub_contract';
export const STEPS_STYLING_MAP: Map<string,IStepStyles>  = new Map ([
  ['task',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'presentation-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'
  }],
  ['file',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'file-text-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'
  }],
  ['credit_letter',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'bank-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
  ['general_credit_letter',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'bank-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
  ['direct_payment',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'wallet-2-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
  ['payment',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'bank-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
  ['sub_contract',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'file-copy-2-fill',
    stepViewBackGround:'#FFFFFF',
     pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
  ['multi_payment',  {
    stepColor:'#FFFFFF',   
    subCountractStepColor:'#FFFFFF',   
    stepActiveColor:'#FFFFFF',
    stepIcon:'coins-fill',
    stepViewBackGround:'#FFFFFF',
    pointerColor:'#FFFFFF',
    stepDeadlineColor:'#1E2938'

  }],
])

export const TagsStylingMap:Map<string,{background:string}> = new Map ([
  ['credit_letter', {background:'#FFFFFF'}],
  ['direct_payment', {background:'#FFFFFF'}],
  ['payment', {background:'#FFFFFF'}],
  ['multi_payment', {background:'#FFFFFF'}],
  ['task', {background:'#FFFFFF'}],
  ['file', {background:'#FFFFFF'}],
  ['sub_contract', {background:'#FFFFFF'}],
  ['Warning', {background:'#FFFFFF'}],
  ['Base', {background:'#FFFFFF'}],
])
export const TagsStylinTextgMap:Map<string,{color:string}> = new Map ([
  ['completed', {color:'#284073'}],
  ['deadline', {color:'#284073'}],
  ['action', {color:'#2563EB'}],
])